import React from "react";
import { IonToolbar, IonButtons, IonBackButton } from "@ionic/react";
import { Logo } from "./Logo";
import styles from "./HelpoHeader.module.css";
import { HelpoDivider } from "./HelpoDivider";

interface HelpoHeaderProps {
  title: string;
  hideBackButton?: boolean;
}

export const HelpoHeader = ({
  title,
  hideBackButton = false,
}: HelpoHeaderProps) => {
  return (
    <div>
      <IonToolbar>
        {!hideBackButton && (
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" />
          </IonButtons>
        )}
        <Logo />
      </IonToolbar>
      <HelpoDivider />
      <IonToolbar>
        <h1 className={`ion-text-left ion-text-wrap ${styles.title}`}>
          {title}
        </h1>
      </IonToolbar>
    </div>
  );
};
